module.exports = __webpack_public_path__ + "static/media/UNL.60ee5e9e.png";